import {
  PaymentSourceKind,
  PaymentFrequency,
} from "@evergiving/common/dist/es2015/pledge";
import {
  startDateGenerators,
  StartDatePaymentMethod,
} from "@/lib/config/startDateGenerators";

const paymentMethodMapping: {
  [key in PaymentSourceKind]: StartDatePaymentMethod;
} = {
  [PaymentSourceKind.StripePayment]: "creditcard",
  [PaymentSourceKind.ApplePay]: "creditcard",
  [PaymentSourceKind.GooglePay]: "creditcard",
  [PaymentSourceKind.CreditCard]: "creditcard",
  [PaymentSourceKind.DirectDebit]: "directdebit",
};

function toStartDatePaymentMethod(
  paymentSourceKind: PaymentSourceKind | undefined
): StartDatePaymentMethod {
  if (!paymentSourceKind) {
    return "other";
  }
  return paymentMethodMapping[paymentSourceKind];
}

const noStartDates: () => Date[] = () => [];

export function getStartDates(
  paymentFrequency: PaymentFrequency | undefined,
  paymentSourceKind: PaymentSourceKind | undefined
): Date[] {
  const startDateGenerator = paymentFrequency
    ? startDateGenerators[paymentFrequency]
    : noStartDates;

  return startDateGenerator
    ? startDateGenerator({
        paymentMethod: toStartDatePaymentMethod(paymentSourceKind),
      })
    : [];
}
